import type { FieldError, RegisterOptions } from 'react-hook-form';

type ValidationOptions = Pick<RegisterOptions, 'required' | 'min' | 'max' | 'maxLength' | 'minLength' | 'pattern'>;

const getValidationRuleValue = (rule: ValidationOptions[keyof ValidationOptions]) => {
    if (typeof rule === 'object' && 'value' in rule) {
        return rule.value;
    }

    return rule;
};

/**
 * Build a sensible error message from the validation failure
 * @param errorType Validation error type, e.g. required
 * @param name Input/field name/label
 * @param validation Validation rules - see React Hook Form
 * @param type Input type, e.g. checkbox
 */
const buildErrorMessage = (
    errorType: FieldError['type'],
    name: string,
    validation: ValidationOptions,
    fieldType: string = ''
) => {
    switch (errorType) {
        case 'required':
            switch (fieldType) {
                case 'checkbox':
                    return `You must select ${name}.`;
                default:
                    return `${name} is required.`;
            }
        case 'maxLength':
            return `${name} cannot exceed ${getValidationRuleValue(validation.maxLength)} characters.`;
        case 'minLength':
            return `${name} should be at least ${getValidationRuleValue(validation.minLength)} characters.`;
        case 'max':
            return `${name} cannot be higher than ${getValidationRuleValue(validation.max)}`;
        case 'min':
            return `${name} cannot be lower than ${getValidationRuleValue(validation.min)}`;
        case 'pattern':
            return `${name} did not match the required pattern.`;
        default:
            return 'This value is invalid.';
    }
};

export default buildErrorMessage;
